/*
Descrição..........: Importação de módulos externos e declaração de módulos locais
Autor..............: Pablo Ebbers
Data Criação.......: 01/03/2020
Última Atualização.: 17/03/2020
*/


import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProdutoFormPageRoutingModule } from './produto-form-routing.module';

import { ProdutoFormPage } from './produto-form.page';

import { DropdownModule } from 'primeng/dropdown';

import { ButtonModule } from 'primeng/button';

import {InputNumberModule} from 'primeng/inputnumber';

import { CurrencyMaskModule } from 'ng2-currency-mask';

import {MultiSelectModule} from 'primeng/multiselect';

import {DialogModule} from 'primeng/dialog';

import {SelectButtonModule} from 'primeng/selectbutton';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    InputNumberModule,
    CurrencyMaskModule,
    SelectButtonModule,
    MultiSelectModule,
    ButtonModule,
    IonicModule,
    DropdownModule,
    ProdutoFormPageRoutingModule
  ],
  declarations: [ProdutoFormPage]
})
export class ProdutoFormPageModule {}
